import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { UserService } from './services/user/user.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'KnoMi.Web';

  userIsLoggedIn: boolean = false;
  currentUrl = '';
  private navSub?: Subscription;

  public options = {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: false,
    maxLength: 10,


  }

  constructor(private userService: UserService, private router: Router) {
    this.currentUrl = this.router.url || '';
    this.refreshLoginState();
    this.navSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const nav = event as NavigationEnd;
        this.currentUrl = nav.urlAfterRedirects || nav.url || '';
        this.refreshLoginState();
      });
  }

  ngOnDestroy() {
    this.navSub?.unsubscribe();
  }

  private refreshLoginState() {
    const token = this.userService.hasToken();
    const isLoginRoute = this.currentUrl.startsWith('/login');
    this.userIsLoggedIn = token && !isLoginRoute;
  }

  onLogout() {
    this.userService.logout();
  }
}
